import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Redes from './Redes';
import IPs from './IPs';
import DNS from './DNS';
import Portas from './Portas';
import Roteador from '../Roteador';
import Cabos from './Cabos';
import Internet from './Internet';
import Wifi from './Wifi';

import * as AiIcons from "react-icons/ai";
import * as BiIcons from "react-icons/bi";
import * as FcIcons from "react-icons/fc";
import * as MdIcons from "react-icons/md";

function Rede() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [location.pathname]);

    const [activeTab, setActiveTab] = useState('/redes');

    const handleTabSelect = (selectedTab) => {
        setActiveTab(selectedTab);
    };

    return (
        <div><br />
            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                <Nav fill variant="tabs" defaultActiveKey="/redes">
                    <Nav.Item>
                        <Nav.Link eventKey="/redes">
                            <div className='aba-menu'>
                                <h4><AiIcons.AiOutlineApartment /></h4>
                                <h5>Rede Local/Internet</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/internet">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcGlobe /></h4>
                                <h5>Internet</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/wifi">
                            <div className='aba-menu'>
                                <h4><BiIcons.BiRss /></h4>
                                <h5>Redes Wi-Fi</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/ips">
                            <div className='aba-menu'>
                                <h4><BiIcons.BiGitBranch /></h4>
                                <h5>Endereço IP</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/dns">
                            <div className='aba-menu'>
                                <h4><MdIcons.MdDomain /></h4>
                                <h5>DNS</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/portas">
                            <div className='aba-menu'>
                                <h4><BiIcons.BiDoorOpen /></h4>
                                <h5>Portas</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/roteadores">
                            <div className='aba-menu'>
                                <h4><BiIcons.BiRss /></h4>
                                <h5>Roteadores</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/cabos">
                            <div className='aba-menu'>
                                <h4><BiIcons.BiRss /></h4>
                                <h5>Cabos de Redes</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content className='container'>
                    <Tab.Pane eventKey="/redes">
                        <Redes />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/internet">
                        <Internet />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/wifi">
                        <Wifi />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/ips">
                        <IPs />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/dns">
                        <DNS />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/portas">
                        <Portas />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/roteadores">
                        <Roteador />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/cabos">
                        <Cabos />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    );
}

export default Rede;
